/* eslint-disable */

const arrayExtensions = (function () {
    if (!Array.prototype.max || !Array.prototype.min || !Array.prototype.sum || !Array.prototype.distinct) {
        Array.prototype.max = function (predicate) {
            return this.reduce((prev: any, current: any) => {
                return predicate(prev) > predicate(current) ? prev : current;
            });
        };
        Array.prototype.min = function (predicate) {
            return this.reduce((prev: any, current: any) => {
                return predicate(prev) < predicate(current) ? prev : current;
            });
        };
        Array.prototype.sum = function (predicate) {
            return this.reduce((prev: any, current: any) => {
                return prev + predicate(current);
            }, 0)
        };
        Array.prototype.distinct = function (predicate) {
            const convertedArray: any[] = this.map((v: any) => predicate(v));
            return this.filter((value: any, index: number) => convertedArray.indexOf(predicate(value)) === index);
        };
    }
})();

export default arrayExtensions;